import { useState } from "react";
import { useTranslation } from "react-i18next";

import Input from "../Input";

import "./style.scss";

export const DurationInput = ({
  label,
  valueHour,
  valueMin,
  onChange,
  onFocus,
  onBlur,
  required = true,
  infoText = "",
  errorfromparent = "",
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState("");

  const handleHoursChange = (e) => {
    if (onChange) onChange(e);
  };

  const handleMinutesChanged = (e) => {
    if (onChange) onChange(e);
  };

  const handleFocus = (e) => {
    setError("");

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    const { value } = e.target;
    if (!value && !valueHour && !valueMin && required) {
      setError(t("error_input_required"));
    }

    if (onBlur) {
      onBlur(e);
    }
  };

  const errorMsg = errorfromparent || error;

  return (
    <div className={`duration-input-container`}>
      {label && <label>{label}</label>}
      <div className="inputs-container">
        <Input
          type="wholeNumber"
          label={t("hour")}
          name="hours"
          value={valueHour}
          onChange={handleHoursChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          hasError={!!errorMsg}
        />

        <Input
          type="wholeNumber"
          label={t("minute")}
          name="minutes"
          value={valueMin}
          onChange={handleMinutesChanged}
          hasError={!!errorMsg}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>

      {!!errorMsg && <div className="error-message">{errorMsg}</div>}
      {infoText && <div className="info-message">{infoText}</div>}
    </div>
  );
};
